const currentYear = () => new Date().getFullYear();

export { currentYear };
